import React from 'react'
import TourOfferLoadTile from './TourOfferLoadTile'
import styled from 'styled-components'
import { fillArray, take } from 'lib/array/arrayUtils'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'
import TourTileSkeletonLoader from 'components/Tours/TourTiles/TourTileSkeletonLoader'

interface Props {
  tourIds: App.OfferList;
  category: string;
  limit?: number;
}

const Wrapper = styled.div`
  width: 100%;
`

function TourSearchTileList(props: Props) {
  const { tourIds, category, limit = 8 } = props
  return <Wrapper>
    <FullWidthCarousel gap={24} itemsPerArrow={4}>
      {tourIds.fetching && fillArray(4).map((_, index) => <TourTileSkeletonLoader key={index} />)}
      {take(tourIds.offerIds, limit).map((id: string, index: number) => (
        <TourOfferLoadTile
          key={id}
          id={id}
          index={index}
          lazyLoad
          category={category}
        />))}
    </FullWidthCarousel>
  </Wrapper>
}

export default TourSearchTileList
